import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, Teleport as _Teleport, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "flex h-full max-h-full flex-col" }
const _hoisted_2 = { class: "flex h-full flex-col gap-2 overflow-y-scroll p-2.5 pt-0" }

import { Ref, ref } from 'vue';
import { Router, useRouter } from 'vue-router';
import { BlackDesertItem, BlackDesertItemQueue } from '@blackdesertmarket/interfaces';
import { isValidBlackDesertItemQueue } from '@blackdesertmarket/objects';
import { ListFilterData } from '@/interfaces/list-filter';
import { LoaderSize } from '@/enums/loader';
import { UseItemQueueReturn, useItemQueue } from '@/composables/item-queue/use-item-queue';
import { UseQueueItemListReturn, useItemQueueFetch } from '@/composables/item-queue/use-item-queue-fetch';
import { UseItemReturn, useItem } from '@/composables/item/use-item';
import { UseListFilterReturn, useListFilter } from '@/composables/list-filter/use-list-filter';
import { TranslateKey, useInject } from '@/composables/use-inject';
import AppLoader from '@/components/Base/AppLoader/AppLoader.vue';
import ItemDetailsModal from '@/components/ItemDetails/ItemDetailsModal.vue';
import ListFilter from '@/components/ListFilter/ListFilter.vue';
import ListItem from '@/components/ListItem/ListItem.vue';
import ListItemProperty from '@/components/ListItem/ListItemProperty.vue';
import ListItemSeparator from '@/components/ListItem/ListItemSeparator.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemQueueList',
  setup(__props) {

const translate = useInject(TranslateKey);
const router: Router = useRouter();
const itemQueueFetch: UseQueueItemListReturn = useItemQueueFetch();

const loaded: Ref<boolean> = ref(false);
const search: Ref<boolean> = ref(false);
const itemList: Ref<BlackDesertItem[] | BlackDesertItemQueue[]> = ref([]);
const activeItem: Ref<BlackDesertItemQueue | null> = ref(null);

const getBasePrice = (item: BlackDesertItem | BlackDesertItemQueue): string => {
  const itemComposable: UseItemReturn = useItem(item);
  return itemComposable.getBasePrice();
};

const getEndTime = (item: BlackDesertItem | BlackDesertItemQueue): string => {
  if (!isValidBlackDesertItemQueue(item)) {
    return '';
  }

  const itemQueueComposable: UseItemQueueReturn = useItemQueue(item);
  return itemQueueComposable.getEndTime();
};

const refetchQueueItemList = (): Promise<void> => {
  return itemQueueFetch.fetch().then((data: BlackDesertItemQueue[]): void => {
    itemList.value = data;
    loaded.value = true;
  });
};

const handleListItemClick = (item: BlackDesertItem | BlackDesertItemQueue): void => {
  if (isValidBlackDesertItemQueue(item)) {
    activeItem.value = activeItem.value !== item ? item : null;
    return;
  }

  router.push({
    name: 'item',
    params: {
      id: item.id,
    },
  });
};

const handleListFilter = async (data: ListFilterData): Promise<void> => {
  const listFilter: UseListFilterReturn = useListFilter(data);

  await listFilter.processItemList({
    itemList: itemList,
    loaded: loaded,
    fallback(): Promise<void> {
      return refetchQueueItemList().then((): void => {
        search.value = false;
      });
    },
    callback(): void {
      search.value = true;
    },
  });
};

if (!itemList.value.length) {
  refetchQueueItemList();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(ListFilter, { onFilter: handleListFilter }),
      _createElementVNode("div", _hoisted_2, [
        (search.value)
          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(itemList.value, (item) => {
              return (_openBlock(), _createBlock(ListItem, {
                key: item.id,
                item: item,
                onEffect: ($event: any) => (handleListItemClick(item))
              }, null, 8, ["item", "onEffect"]))
            }), 128))
          : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(itemList.value, (item) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: item.id
              }, [
                _createVNode(ListItem, {
                  item: item,
                  onEffect: ($event: any) => (handleListItemClick(item))
                }, {
                  append: _withCtx(() => [
                    _createVNode(ListItemSeparator),
                    _createVNode(ListItemProperty, {
                      label: _unref(translate)('itemQueue.basePrice'),
                      value: getBasePrice(item)
                    }, null, 8, ["label", "value"]),
                    _createVNode(ListItemSeparator),
                    _createVNode(ListItemProperty, {
                      label: _unref(translate)('itemQueue.endTime'),
                      value: getEndTime(item)
                    }, null, 8, ["label", "value"])
                  ]),
                  _: 2
                }, 1032, ["item", "onEffect"]),
                (activeItem.value === item)
                  ? (_openBlock(), _createBlock(_Teleport, {
                      key: 0,
                      to: "#modal"
                    }, [
                      (_unref(isValidBlackDesertItemQueue)(item))
                        ? (_openBlock(), _createBlock(ItemDetailsModal, {
                            key: 0,
                            id: item.id,
                            enhancement: item.enhancement,
                            onClose: ($event: any) => (handleListItemClick(item))
                          }, null, 8, ["id", "enhancement", "onClose"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
      ])
    ]),
    (!loaded.value)
      ? (_openBlock(), _createBlock(AppLoader, {
          key: 0,
          size: _unref(LoaderSize).LARGE,
          overlay: ""
        }, null, 8, ["size"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})